import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-42f7c1ec")

_pushScopeId("data-v-42f7c1ec")
const _hoisted_1 = { ref: "form" }
const _hoisted_2 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_3 = { class: "input-row" }
const _hoisted_4 = { class: "dont-print" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Pool Design Plans ")
const _hoisted_6 = {
  key: 0,
  style: {"margin-left":"10px"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Please verify the following information is included in your plans prior to uploading files. ")
const _hoisted_8 = {
  key: 1,
  class: "data-table",
  style: {"margin":"20px 0"}
}
const _hoisted_9 = /*#__PURE__*/_createVNode("thead", null, [
  /*#__PURE__*/_createVNode("tr", null, [
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "Yes"),
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "No"),
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "N/A"),
    /*#__PURE__*/_createVNode("th", { class: "label-cell" }, "Design plan requirements")
  ])
], -1)
const _hoisted_10 = {
  key: 0,
  class: "text-color-red"
}
const _hoisted_11 = {
  key: 2,
  class: "text-align-center text-color-red"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Pump Type")
const _hoisted_13 = /*#__PURE__*/_createVNode("div", null, "Agitation system, single pump, no HydroTrough", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("div", null, "Agitation system, dual pump with HydroTrough", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("div", null, "Inteligent cleaning system, single pump, no Hydro trough", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("div", null, "Inteligent zone by zone cleaning system, dedicated cleaning system pump with hydro trough", -1)
const _hoisted_17 = { class: "input-row" }
const _hoisted_18 = { style: {"flex":"3"} }
const _hoisted_19 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_20 = { class: "input-row" }
const _hoisted_21 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_23 = { class: "input-row" }
const _hoisted_24 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_25 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_26 = /*#__PURE__*/_createVNode("option", {
  value: "",
  disabled: ""
}, "Please choose...", -1)
const _hoisted_27 = { style: {"display":"none"} }
const _hoisted_28 = { class: "input-row" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_f7_list_input = _resolveComponent("f7-list-input")
  const _component_f7_link = _resolveComponent("f7-link")
  const _component_f7_block_title = _resolveComponent("f7-block-title")
  const _component_f7_block = _resolveComponent("f7-block")
  const _component_f7_checkbox = _resolveComponent("f7-checkbox")
  const _component_file_upload = _resolveComponent("file-upload")
  const _component_f7_list_item = _resolveComponent("f7-list-item")
  const _component_f7_list = _resolveComponent("f7-list")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("form", _hoisted_1, [
      _createVNode(_component_f7_list, null, {
        default: _withId(() => [
          _createVNode("div", null, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              outline: "",
              label: "Request type",
              type: "select",
              value: _ctx.requestType,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => (_ctx.requestType = $event)),
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_2,
                _createVNode("option", {
                  value: "quote",
                  disabled: _ctx.readonly
                }, "Need quote", 8, ["disabled"]),
                _createVNode("option", {
                  value: "sold",
                  disabled: _ctx.readonly
                }, "Pool is sold", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["readonly", "value", "required"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              type: "text",
              value: _ctx.projectAddress.address,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.projectAddress.address = $event)),
              label: "Project address",
              name: "address",
              outline: "",
              required: "",
              validate: ""
            }, null, 8, ["readonly", "value"]),
            _createVNode("div", _hoisted_3, [
              _createVNode(_component_f7_list_input, {
                readonly: _ctx.readonly,
                type: "text",
                style: {"flex":"3"},
                value: _ctx.projectAddress.city,
                "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => (_ctx.projectAddress.city = $event)),
                label: "City",
                name: "city",
                outline: "",
                required: "",
                validate: ""
              }, null, 8, ["readonly", "value"]),
              _createVNode(_component_f7_list_input, {
                readonly: _ctx.readonly,
                type: "text",
                style: {"flex":"2"},
                value: _ctx.projectAddress.state,
                "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => (_ctx.projectAddress.state = $event)),
                label: "State",
                name: "state",
                outline: "",
                required: "",
                validate: ""
              }, null, 8, ["readonly", "value"]),
              _createVNode(_component_f7_list_input, {
                readonly: _ctx.readonly,
                type: "text",
                style: {"flex":"1"},
                value: _ctx.projectAddress.zip,
                "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => (_ctx.projectAddress.zip = $event)),
                label: "Zip",
                name: "zip",
                outline: "",
                required: "",
                validate: ""
              }, null, 8, ["readonly", "value"])
            ])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              type: "tel",
              value: _ctx.phoneNumber,
              "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => (_ctx.phoneNumber = $event)),
              label: "Phone Number",
              name: "phone-number",
              outline: "",
              validate: ""
            }, null, 8, ["readonly", "value"])
          ]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_f7_block_title, { class: "display-flex" }, {
              default: _withId(() => [
                _hoisted_5,
                (_ctx.isDraft)
                  ? (_openBlock(), _createBlock("div", _hoisted_6, [
                      (!_ctx.validChecklist)
                        ? (_openBlock(), _createBlock(_component_f7_link, {
                            key: 0,
                            tooltip: "You've left one of the check boxes as 'no' or empty.",
                            color: "red",
                            "icon-f7": "exclamationmark_octagon"
                          }))
                        : (_openBlock(), _createBlock(_component_f7_link, {
                            key: 1,
                            tooltip: "Your design meets all requirements.",
                            color: "green",
                            "icon-f7": "checkmark_circle"
                          }))
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (_ctx.isDraft)
              ? (_openBlock(), _createBlock(_component_f7_block, { key: 0 }, {
                  default: _withId(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.isDraft)
              ? (_openBlock(), _createBlock("div", _hoisted_8, [
                  _createVNode("table", null, [
                    _hoisted_9,
                    _createVNode("tbody", null, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.checklist, (c, i) => {
                        return (_openBlock(), _createBlock("tr", { key: i }, [
                          _createVNode("td", null, [
                            _createVNode(_component_f7_checkbox, {
                              checked: c.value === 'yes',
                              onChange: ($event: any) => (_ctx.updateChecklist(i, 'yes'))
                            }, null, 8, ["checked", "onChange"])
                          ]),
                          _createVNode("td", null, [
                            _createVNode(_component_f7_checkbox, {
                              checked: c.value === 'no',
                              onChange: ($event: any) => (_ctx.updateChecklist(i, 'no'))
                            }, null, 8, ["checked", "onChange"])
                          ]),
                          _createVNode("td", null, [
                            (c.optional)
                              ? (_openBlock(), _createBlock(_component_f7_checkbox, {
                                  key: 0,
                                  checked: c.value === 'na',
                                  onChange: ($event: any) => (_ctx.updateChecklist(i, 'na'))
                                }, null, 8, ["checked", "onChange"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createVNode("td", null, [
                            _createVNode("div", null, _toDisplayString(c.description), 1),
                            (c.value === 'no')
                              ? (_openBlock(), _createBlock("small", _hoisted_10, " This is required. Please revise design plans" + _toDisplayString(c.optional ? ' or select N/A.' : "."), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_file_upload, {
              ref: "filesComponent",
              job: _ctx.job,
              allowedTypes: ['dwg', 'dwf', 'dxf', 'pdf'],
              dir: "/builder",
              readonly: _ctx.readonly || (_ctx.isDraft && !_ctx.validChecklist)
            }, null, 8, ["job", "readonly"]),
            (_ctx.isDraft && !_ctx.validChecklist)
              ? (_openBlock(), _createBlock("p", _hoisted_11, " Complete the checklist above to upload plans. "))
              : _createCommentVNode("", true)
          ]),
          _createVNode("div", null, [
            _createVNode(_component_f7_block_title, null, {
              default: _withId(() => [
                _hoisted_12
              ]),
              _: 1
            }),
            _createVNode(_component_f7_list, null, {
              default: _withId(() => [
                _createVNode(_component_f7_list_item, {
                  radio: "",
                  name: "pump-type-radio",
                  value: "Pul Klean",
                  title: "Pul Klean",
                  checked: _ctx.pumpType === 'Pul Klean',
                  onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.pumpType = 'Pul Klean')),
                  disabled: _ctx.readonly
                }, {
                  footer: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["checked", "disabled"]),
                _createVNode(_component_f7_list_item, {
                  radio: "",
                  name: "pump-type-radio",
                  value: "Pul Klean Pro",
                  title: "Pul Klean Pro",
                  checked: _ctx.pumpType === 'Pul Klean Pro',
                  onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.pumpType = 'Pul Klean Pro')),
                  disabled: _ctx.readonly
                }, {
                  footer: _withId(() => [
                    _hoisted_14
                  ]),
                  _: 1
                }, 8, ["checked", "disabled"]),
                (_ctx.canSeeConnekt)
                  ? (_openBlock(), _createBlock(_component_f7_list_item, {
                      key: 0,
                      radio: "",
                      name: "pump-type-radio",
                      value: "Pul Connekt",
                      title: "Pul Connekt",
                      checked: _ctx.pumpType === 'Pul Connekt',
                      onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.pumpType = 'Pul Connekt')),
                      disabled: _ctx.readonly
                    }, {
                      footer: _withId(() => [
                        _hoisted_15
                      ]),
                      _: 1
                    }, 8, ["checked", "disabled"]))
                  : _createCommentVNode("", true),
                (_ctx.canSeeConnekt)
                  ? (_openBlock(), _createBlock(_component_f7_list_item, {
                      key: 1,
                      radio: "",
                      name: "pump-type-radio",
                      value: "Pul Connekt Pro",
                      title: "Pul Connekt Pro",
                      checked: _ctx.pumpType === 'Pul Connekt Pro',
                      onChange: _cache[10] || (_cache[10] = ($event: any) => (_ctx.pumpType = 'Pul Connekt Pro')),
                      disabled: _ctx.readonly
                    }, {
                      footer: _withId(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }, 8, ["checked", "disabled"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_17, [
            _createVNode("div", _hoisted_18, [
              _createVNode(_component_f7_list_input, {
                outline: "",
                label: "Filter type",
                type: "select",
                value: _ctx.filterType,
                "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => (_ctx.filterType = $event)),
                required: !_ctx.readonly,
                validate: ""
              }, {
                default: _withId(() => [
                  _hoisted_19,
                  _createVNode("option", {
                    value: "de",
                    disabled: _ctx.readonly
                  }, "D.E.", 8, ["disabled"]),
                  _createVNode("option", {
                    value: "sand",
                    disabled: _ctx.readonly
                  }, "Sand", 8, ["disabled"]),
                  _createVNode("option", {
                    value: "cartridge",
                    disabled: _ctx.readonly
                  }, "Cartridge", 8, ["disabled"])
                ]),
                _: 1
              }, 8, ["value", "required"])
            ]),
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              value: _ctx.filterModel,
              "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => (_ctx.filterModel = $event)),
              type: "text",
              style: {"flex":"1"},
              label: "mfg/Model",
              outline: "",
              required: "",
              validate: ""
            }, null, 8, ["readonly", "value"])
          ]),
          _createVNode("div", _hoisted_20, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              outline: "",
              label: "Nozzle color",
              type: "select",
              value: _ctx.color,
              "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => (_ctx.color = $event)),
              style: {"flex":"1"},
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_21,
                _createVNode("option", {
                  value: "TBD",
                  disabled: _ctx.readonly
                }, "TBD", 8, ["disabled"]),
                _createVNode("option", {
                  value: "W",
                  disabled: _ctx.readonly
                }, "White", 8, ["disabled"]),
                _createVNode("option", {
                  value: "LG",
                  disabled: _ctx.readonly
                }, "Light Grey", 8, ["disabled"]),
                _createVNode("option", {
                  value: "G",
                  disabled: _ctx.readonly
                }, "Grey", 8, ["disabled"]),
                _createVNode("option", {
                  value: "BL",
                  disabled: _ctx.readonly
                }, "Black", 8, ["disabled"]),
                _createVNode("option", {
                  value: "LB",
                  disabled: _ctx.readonly
                }, "Light Blue", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["readonly", "value", "required"]),
            _createVNode(_component_f7_list_input, {
              style: {"flex":"1"},
              readonly: _ctx.readonly,
              outline: "",
              label: "Pool finish",
              type: "select",
              value: _ctx.finish,
              "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.finish = $event)),
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_22,
                _createVNode("option", {
                  value: "pebble",
                  disabled: _ctx.readonly
                }, "Pebble", 8, ["disabled"]),
                _createVNode("option", {
                  value: "pebbleSheen",
                  disabled: _ctx.readonly
                }, "Pebble Sheen & Beadcrete", 8, ["disabled"]),
                _createVNode("option", {
                  value: "plaster",
                  disabled: _ctx.readonly
                }, "Plaster", 8, ["disabled"]),
                _createVNode("option", {
                  value: "tile",
                  disabled: _ctx.readonly
                }, "Tile", 8, ["disabled"]),
                _createVNode("option", {
                  value: "fiberglass",
                  disabled: _ctx.readonly
                }, "Fiberglass", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["readonly", "value", "required"])
          ]),
          _createVNode("div", _hoisted_23, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              outline: "",
              label: "Does the contractor want heads in spas?",
              type: "select",
              value: _ctx.spaHeads,
              "onUpdate:value": _cache[15] || (_cache[15] = ($event: any) => (_ctx.spaHeads = $event)),
              style: {"flex":"1"},
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_24,
                _createVNode("option", {
                  value: "yes",
                  disabled: _ctx.readonly
                }, "Yes", 8, ["disabled"]),
                _createVNode("option", {
                  value: "no",
                  disabled: _ctx.readonly
                }, "No", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["readonly", "value", "required"]),
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              outline: "",
              label: "Are there are any semi permanent fixtures on the Baja shelf to account for?",
              type: "select",
              value: _ctx.bajaFixtures,
              "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => (_ctx.bajaFixtures = $event)),
              style: {"flex":"1"},
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_25,
                _createVNode("option", {
                  value: "yes",
                  disabled: _ctx.readonly
                }, "Yes", 8, ["disabled"]),
                _createVNode("option", {
                  value: "no",
                  disabled: _ctx.readonly
                }, "No", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["readonly", "value", "required"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_f7_list_input, {
              outline: "",
              label: "Drain type",
              type: "select",
              value: _ctx.drainType,
              "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => (_ctx.drainType = $event)),
              required: !_ctx.readonly,
              validate: ""
            }, {
              default: _withId(() => [
                _hoisted_26,
                _createVNode("option", {
                  value: "LD1W",
                  disabled: _ctx.readonly
                }, " LD1 - White ", 8, ["disabled"]),
                _createVNode("option", {
                  value: "LD1G",
                  disabled: _ctx.readonly
                }, " LD1 - Grey ", 8, ["disabled"]),
                _createVNode("option", {
                  value: "other",
                  disabled: _ctx.readonly
                }, " Other ", 8, ["disabled"])
              ]),
              _: 1
            }, 8, ["value", "required"])
          ]),
          _createVNode("div", null, [
            _createVNode(_component_f7_list_input, {
              readonly: _ctx.readonly,
              type: "textarea",
              value: _ctx.notes,
              "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => (_ctx.notes = $event)),
              label: "Notes",
              placeholder: "Include any additional details or features necessary for design.",
              outline: ""
            }, null, 8, ["readonly", "value"])
          ])
        ]),
        _: 1
      })
    ], 512),
    _createVNode("div", _hoisted_27, [
      _createVNode("div", {
        id: 'EF-' + _ctx.id
      }, [
        _createVNode(_component_f7_list, null, {
          default: _withId(() => [
            _createVNode("div", null, " REQUEST TYPE: " + _toDisplayString(_ctx.requestType), 1),
            _createVNode("div", null, [
              _createVNode(_component_f7_list_input, {
                readonly: _ctx.readonly,
                type: "text",
                value: _ctx.projectAddress.address,
                "onUpdate:value": _cache[19] || (_cache[19] = ($event: any) => (_ctx.projectAddress.address = $event)),
                label: "Project address",
                name: "address",
                outline: "",
                required: "",
                validate: ""
              }, null, 8, ["readonly", "value"]),
              _createVNode("div", _hoisted_28, [
                _createVNode(_component_f7_list_input, {
                  readonly: _ctx.readonly,
                  type: "text",
                  style: {"flex":"3"},
                  value: _ctx.projectAddress.city,
                  "onUpdate:value": _cache[20] || (_cache[20] = ($event: any) => (_ctx.projectAddress.city = $event)),
                  label: "City",
                  name: "city",
                  outline: "",
                  required: "",
                  validate: ""
                }, null, 8, ["readonly", "value"]),
                _createVNode(_component_f7_list_input, {
                  readonly: _ctx.readonly,
                  type: "text",
                  style: {"flex":"2"},
                  value: _ctx.projectAddress.state,
                  "onUpdate:value": _cache[21] || (_cache[21] = ($event: any) => (_ctx.projectAddress.state = $event)),
                  label: "State",
                  name: "state",
                  outline: "",
                  required: "",
                  validate: ""
                }, null, 8, ["readonly", "value"]),
                _createVNode(_component_f7_list_input, {
                  readonly: _ctx.readonly,
                  type: "text",
                  style: {"flex":"1"},
                  value: _ctx.projectAddress.zip,
                  "onUpdate:value": _cache[22] || (_cache[22] = ($event: any) => (_ctx.projectAddress.zip = $event)),
                  label: "Zip",
                  name: "zip",
                  outline: "",
                  required: "",
                  validate: ""
                }, null, 8, ["readonly", "value"])
              ])
            ]),
            _createVNode("div", null, [
              _createVNode(_component_f7_list_input, {
                readonly: _ctx.readonly,
                type: "tel",
                value: _ctx.phoneNumber,
                "onUpdate:value": _cache[23] || (_cache[23] = ($event: any) => (_ctx.phoneNumber = $event)),
                label: "Phone Number",
                name: "phone-number",
                outline: "",
                validate: ""
              }, null, 8, ["readonly", "value"])
            ]),
            _createVNode("div", null, " PUMP TYPE: " + _toDisplayString(_ctx.pumpType), 1),
            _createVNode("div", null, " MODEL: " + _toDisplayString(_ctx.pumpModel), 1),
            _createVNode("div", null, " FILTER TYPE: " + _toDisplayString(_ctx.filterType), 1),
            _createVNode("div", null, " CARTRIDGE: " + _toDisplayString(_ctx.filterModel), 1),
            _createVNode("div", null, " NOZZLE COLOR: " + _toDisplayString(_ctx.color), 1),
            _createVNode("div", null, " FINISH: " + _toDisplayString(_ctx.finish), 1),
            _createVNode("div", null, " Does the contractor want heads in spas?: " + _toDisplayString(_ctx.spaHeads), 1),
            _createVNode("div", null, " Are there are any semi permanent fixtures on the Baja shelf to account for?: " + _toDisplayString(_ctx.bajaFixtures), 1),
            _createVNode("div", null, " DRAIN TYPE: " + _toDisplayString(_ctx.drainType), 1),
            _createVNode("div", null, " NOTES: " + _toDisplayString(_ctx.notes), 1)
          ]),
          _: 1
        })
      ], 8, ["id"])
    ])
  ], 64))
})